module.exports = __webpack_public_path__ + "assets/img/help-circle.550c137e.svg";